import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/components/_notation.scss'

import { Props, SpanAttributes } from '../utils/types'

export namespace NotationVariantNS {
  export const error = 'error'
  export const none = ''
  export const pagination = 'pagination'
  export const required = 'required'
}

type NotationVariant =
  | typeof NotationVariantNS.error
  | typeof NotationVariantNS.none
  | typeof NotationVariantNS.pagination
  | typeof NotationVariantNS.required

export interface NotationProps extends Props {
  variant?: NotationVariant
}

const cx = bind(styles)

const Notation = React.forwardRef<
  HTMLSpanElement,
  SpanAttributes & NotationProps
>(
  (
    { children, className, variant = NotationVariantNS.none, ...props },
    ref
  ) => (
    <span
      ref={ref}
      className={cx(
        'core-notation',
        {
          [`core-notation--${variant}`]: variant,
        },
        className
      )}
      {...props}
    >
      {children}
    </span>
  )
)

Notation.displayName = 'Notation'

export default Notation
